import "./styles.css";
import Sortable from 'sortablejs';

// Firebase initialization
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider, signOut, getRedirectResult } from "firebase/auth";
import { getFirestore, onSnapshot, doc, getDoc, updateDoc, arrayRemove, arrayUnion, collection, query, orderBy } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDt8zpA_zBe7YFJiM7MNGNORLWwxSFxHJc",
  authDomain: "lil-blessings-hd-ultrasound.firebaseapp.com",
  projectId: "lil-blessings-hd-ultrasound",
  storageBucket: "lil-blessings-hd-ultrasound.firebasestorage.app",
  messagingSenderId: "256554966726",
  appId: "1:256554966726:web:1b1d72b639bb8aa8cbc1c7",
  measurementId: "G-TJY69RH7WK"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

// Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise
// site key and pass it to initializeAppCheck().
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6LeqHt0qAAAAAF5XfdwcO3BNTZuTpzvdHOazvmGS'),
  isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
});

var currentPage = window.location.pathname;


function showMessageModal({ msg, title = "Success", color = "green" }) {
  const modalEl = document.getElementById("messageModal");
  const header = document.getElementById("messageModalHeader");
  const titleEl = document.getElementById("messageModalTitle");
  const msgEl = document.getElementById("messageModalMsg");
  console.log("🥷 showMessageModal called:", { modalEl, header, titleEl, msgEl });

  if (!modalEl || !header || !titleEl || !msgEl) {
    console.error("Modal DOM elements missing!");
    return;
  }
  console.log("💬 showMessageModal", { msg, title, color });
  const modal = document.getElementById("messageModal");
  if (!modal) {
    return console.error("❌ messageModal element not found!");
  }
  header.className = `w3-container w3-${color}`;

  document.getElementById("messageModalTitle").innerText = title;
  document.getElementById("messageModalMsg").innerText = msg;

  document.getElementById("messageModal").classList.remove("hidden");
}

async function runWithModal(asyncFn, options = {}) {
  showMessageModal({ title: options.loadingTitle, msg: options.loadingMsg, color: options.loadingColor });
  try {
    const result = await asyncFn();
    showMessageModal({ title: options.successTitle, msg: options.successMsg, color: options.successColor });
    return result;
  } catch (err) {
    showMessageModal({ title: "Error", msg: err.message, color: options.errorColor || "red" });
    throw err;
  }
}

function cacheHandles() {
  return {
    loginSection: document.getElementById("loginSection"),
    loginLoader: document.getElementById("loginLoader"),
    functionLoader: document.getElementById("functionLoader"),
    populateLoader: document.getElementById("populateLoader"),
    page: document.getElementById("page"),
    gmailButton: document.querySelector(".googleButton"),
    logoutButton: document.querySelector(".signOutButton"),
    openSidebarBtn: document.getElementById("openSidebarBtn"),
    overlay: document.getElementById("overlay"),
    sidebar: document.getElementById("w3Sidebar"),
  };
}


if (currentPage === '/' || currentPage === '/index.html') {
  /** Show the admin UI, verify admin claims, wire logout */
  async function handleSignedIn(user, handles) {
    const {
      loginSection, loginLoader, functionLoader,
      pageContent, logoutButton
    } = handles;

    // Hide login/loaders, show admin
    loginSection.classList.add("hidden");
    loginLoader.classList.add("hidden");
    functionLoader.classList.add("hidden");
    pageContent.classList.remove("hidden");

    // Verify admin via your callable
    const idTokenResult = await user.getIdTokenResult();
    const gate = httpsCallable(functions, "lilBlessingAccess");
    const { openGateFlag, openGateCode, gateKeeper, returnedKeys } =
      (await gate({
        currentUrl: window.location.href,
        userClaimInfo: idTokenResult.claims
      })).data;

    if (openGateFlag !== openGateCode || openGateFlag === gateKeeper) {
      // Not an admin: sign out and show login
      console.warn("Not authorized as admin, signing out.");
      await signOut(auth);
      handleSignedOut(handles);
      return;
    }

    // Store your function keys for later calls
    window.goodKeys = new Map(Object.entries(returnedKeys));

    // Wire logout
    // Ensure your logout button is wired exactly once:
    handles.logoutButton.onclick = async () => {
      try {
        await signOut(auth);
        console.log("User signed out");
        handleSignedOut(handles);
      } catch (e) {
        console.error("Sign-out error:", e);
      }
    };
  }

  /** Show the login form */
  function handleSignedOut(handles) {
    const { loginSection, loginLoader, pageContent } = handles;
    pageContent.classList.add("hidden");
    loginLoader.classList.add("hidden");
    loginSection.classList.remove("hidden");
  }

  // ————————————————————————————————————————————————
  // Main entrypoint
  // ————————————————————————————————————————————————
  document.addEventListener("DOMContentLoaded", async () => {
    const handles = {
      loginSection: document.getElementById("loginSection"),
      loginLoader: document.getElementById("loginLoader"),
      functionLoader: document.getElementById("functionLoader"),
      pageContent: document.getElementById("page"),
      gmailButton: document.querySelector(".googleButton"),
      logoutButton: document.querySelector(".signOutButton"),
      openSidebarBtn: document.getElementById("openSidebarBtn"),
      overlay: document.getElementById("overlay"),
      sidebar: document.getElementById("w3Sidebar")
    };

    // Sidebar toggle
    handles.openSidebarBtn.onclick = () => {
      handles.sidebar.classList.remove("hidden");
      handles.overlay.classList.remove("hidden");
    };
    handles.overlay.onclick = () => {
      handles.sidebar.classList.add("hidden");
      handles.overlay.classList.add("hidden");
    };

    // Sign‑in redirect
    handles.gmailButton.onclick = () => {
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider).catch(err => console.error("Popup sign-in error:", err));
    };

    // 1️⃣ First, process any redirect sign‑in
    try {
      const result = await getRedirectResult(auth);
      if (result?.user) {
        await handleSignedIn(result.user, handles);
        return;
      }
    } catch (e) {
      console.error("getRedirectResult error:", e);
    }

    // 2️⃣ Next, check if already signed‑in
    if (auth.currentUser) {
      await handleSignedIn(auth.currentUser, handles);
      return;
    }

    // 3️⃣ Fallback to persistent listener for later sign‑in/out
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("Auth state changed → signed in:", user.email);
        await handleSignedIn(user, handles);
      } else {
        console.log("Auth state changed → signed out");
        handleSignedOut(handles);
      }
    });
  });
} else if (currentPage === '/userMgmt.html') {
  // ─────────────────────────────────────────────────────────
  // 1) Shared UI & Auth Helpers
  // ─────────────────────────────────────────────────────────
  async function handleSignedIn(user, handles) {
    const {
      loginSection, loginLoader, functionLoader,
      pageContent, logoutButton, populateLoader
    } = handles;

    // Hide login, show loading
    loginSection.classList.add("hidden");
    loginLoader.classList.add("hidden");
    populateLoader.classList.remove("hidden");

    // Verify admin via callable
    const idTokenResult = await user.getIdTokenResult();
    const gate = httpsCallable(functions, "lilBlessingAccess");
    const { openGateFlag, openGateCode, gateKeeper, returnedKeys } =
      (await gate({
        currentUrl: window.location.href,
        userClaimInfo: idTokenResult.claims
      })).data;

    if (openGateFlag !== openGateCode || openGateFlag === gateKeeper) {
      // Not an admin
      await signOut(auth);
      return handleSignedOut(handles);
    }

    // Store function keys
    window.goodKeys = new Map(Object.entries(returnedKeys));

    // Wire logout
    logoutButton.onclick = async () => {
      await signOut(auth);
      handleSignedOut(handles);
    };

    // Show the page
    populateLoader.classList.add("hidden");
    functionLoader.classList.add("hidden");
    pageContent.classList.remove("hidden");

    function initTabs() {
      const tabs = document.querySelectorAll(".tablinks");
      const panels = document.querySelectorAll(".tabcontent");

      if (!tabs.length || !panels.length) {
        console.warn("initTabs: no tabs or panels found:", tabs, panels);
        return;
      }

      tabs.forEach(btn => {
        btn.addEventListener("click", () => {
          // Hide all panels
          panels.forEach(panel => panel.classList.add("hidden"));
          // De-activate all buttons
          tabs.forEach(b => b.classList.remove("active"));

          // Show the one this button targets
          const tabId = btn.getAttribute("data-tab");
          const target = document.getElementById(tabId);
          if (target) {
            target.classList.remove("hidden");
            btn.classList.add("active");
          } else {
            console.error("initTabs: No panel with id=", tabId);
          }
        });
      });

      // Kick off by clicking the first tab
      tabs[0].click();
    }

    // Initialize User Management UI
    initTabs();
    setupCreateForm(handles);
    await setupDeleteForm(handles);
    await setupModifyForm(handles);
  }

  function handleSignedOut(handles) {
    const { loginSection, loginLoader, pageContent, populateLoader } = handles;
    pageContent.classList.add("hidden");
    populateLoader.classList.add("hidden");
    loginLoader.classList.add("hidden");
    loginSection.classList.remove("hidden");
  }

  function setupCreateForm(handles) {
    const form = document.querySelector(".createStaffMemberForm");
    const loader = handles.populateLoader;
    const modal = document.getElementById("submitCreateStaffModal");
    const close = document.querySelector(".closeCreateMessageModal");

    // ensure hidden initially
    loader.classList.add("hidden");
    modal.classList.add("hidden");

    form.onsubmit = async e => {
      e.preventDefault();
      // show loading
      loader.classList.remove("hidden");

      // email match check
      const email = form.signUpEmail.value;
      if (email !== form.confirmEmail.value) {
        loader.classList.add("hidden");
        return alert("Emails must match");
      }

      // uniqueness check
      const checkFn = httpsCallable(functions, window.goodKeys.get("runFunction2"));
      const { state } = (await checkFn({ emailToTest: email })).data;
      if (state === "True") {
        loader.classList.add("hidden");
        return alert("Email already in use");
      }

      // create
      const data = {
        firstName: form.FirstName.value,
        lastName: form.LastName.value,
        priviledges: form.priviledges.value,
        email,
        signUpDateTime: new Date().toLocaleString()
      };
      const createFn = httpsCallable(functions, window.goodKeys.get("runFunction1"));
      await createFn(data);

      // done
      loader.classList.add("hidden");
      form.reset();
      modal.classList.remove("hidden");

      // auto-reload in 1s
      setTimeout(() => window.location.reload(), 1000);
    };

    close.onclick = () => {
      modal.classList.add("hidden");
      window.location.reload();
    };
  }


  async function setupDeleteForm(handles) {
    const form = document.querySelector(".deleteStaffMemberForm");
    const loader = handles.populateLoader;
    const modal = document.getElementById("submitDeleteStaffModal");
    const close = document.querySelector(".closeDeleteMessageModal");
    const fetchFn = httpsCallable(functions, window.goodKeys.get("runFunction3"));
    const delFn = httpsCallable(functions, window.goodKeys.get("runFunction4"));

    // ensure hidden initially
    loader.classList.add("hidden");
    modal.classList.add("hidden");

    // build selector + button
    const select = document.createElement("select");
    select.className = "w3-select w3-border";
    const btn = document.createElement("button");
    btn.type = "submit";
    btn.textContent = "Delete";
    btn.className = "w3-button w3-red w3-margin-top";
    btn.disabled = true;
    form.append(select, btn);

    // populate options
    const { data: { users } } = await fetchFn();
    if (users.length) {
      select.innerHTML = `<option value="">Select a User</option>` +
        users.map(u => `<option value="${u.id}">${u.name || u.id}</option>`).join("");
      btn.disabled = false;
    } else {
      select.innerHTML = `<option>No Users Available</option>`;
    }

    // handle submit
    form.onsubmit = async e => {
      e.preventDefault();
      if (!select.value) return alert("Select a user");
      if (!confirm("Delete this user?")) return;

      loader.classList.remove("hidden");
      await delFn({ userId: select.value });
      loader.classList.add("hidden");
      modal.classList.remove("hidden");


      // auto-reload in 1s
      setTimeout(() => window.location.reload(), 1000);
    };

    // on close: hide modal & reload
    close.onclick = () => {
      modal.classList.add("hidden");
      window.location.reload();
    };
  }


  async function setupModifyForm(handles) {
    const form = document.querySelector(".modifyStaffMemberForm");
    const loader = handles.populateLoader;
    const modal = document.getElementById("submitModifyStaffModal");
    const close = document.querySelector(".closeModifyMessageModal");
    const fetchFn = httpsCallable(functions, window.goodKeys.get("runFunction3"));
    const updateFn = httpsCallable(functions, window.goodKeys.get("runFunction5"));

    // ensure hidden initially
    loader.classList.add("hidden");
    modal.classList.add("hidden");

    // clear and build inputs
    form.innerHTML = "";
    const select = document.createElement("select");
    select.className = "w3-select w3-border";
    const inpF = document.createElement("input");
    inpF.placeholder = "First Name"; inpF.className = "w3-input w3-border";
    const inpL = document.createElement("input");
    inpL.placeholder = "Last Name"; inpL.className = "w3-input w3-border";
    const inpE = document.createElement("input");
    inpE.type = "email"; inpE.placeholder = "Email"; inpE.className = "w3-input w3-border";
    const selP = document.createElement("select");
    selP.className = "w3-select w3-border";
    selP.innerHTML = `
      <option value="">Privilege...</option>
      <option>SUPERADMIN</option>
      <option>ADMIN</option>
      <option>EDITOR</option>
      <option>BASIC</option>`;
    const btn = document.createElement("button");
    btn.type = "submit";
    btn.textContent = "Update User";
    btn.className = "w3-button w3-green w3-margin-top";
    btn.disabled = true;

    form.append(select, inpF, inpL, inpE, selP, btn);

    // populate users
    const { data: { users } } = await fetchFn();
    if (users.length) {
      select.innerHTML = `<option value="">Select a User</option>` +
        users.map(u => `<option value="${u.id}">${u.name} (${u.email})</option>`).join("");
      btn.disabled = false;
    } else {
      select.innerHTML = `<option>No Users</option>`;
    }

    // handle submit
    form.onsubmit = async e => {
      e.preventDefault();
      if (!select.value) return alert("Select a user");

      loader.classList.remove("hidden");
      const updatedData = {
        firstName: inpF.value.trim(),
        lastName: inpL.value.trim(),
        email: inpE.value.trim(),
        privilege: selP.value
      };
      await updateFn({ userId: select.value, updatedData });
      loader.classList.add("hidden");
      modal.classList.remove("hidden");


      // auto-reload in 1s
      setTimeout(() => window.location.reload(), 1000);
    };

    // on close: hide modal & reload
    close.onclick = () => {
      modal.classList.add("hidden");
      window.location.reload();
    };
  }

  // ─────────────────────────────────────────────────────────
  // 3) Initialization on DOMContentLoaded
  // ─────────────────────────────────────────────────────────
  document.addEventListener("DOMContentLoaded", async () => {
    const handles = {
      loginSection: document.getElementById("loginSection"),
      loginLoader: document.getElementById("loginLoader"),
      functionLoader: document.getElementById("functionLoader"),
      pageContent: document.getElementById("page"),
      gmailButton: document.querySelector(".googleButton"),
      logoutButton: document.querySelector(".signOutButton"),
      openSidebarBtn: document.getElementById("openSidebarBtn"),
      overlay: document.getElementById("overlay"),
      sidebar: document.getElementById("w3Sidebar"),
      populateLoader: document.getElementById("populateLoader")
    };

    // Sidebar toggle
    handles.openSidebarBtn.onclick = () => {
      handles.sidebar.classList.remove("hidden");
      handles.overlay.classList.remove("hidden");
    };
    handles.overlay.onclick = () => {
      handles.sidebar.classList.add("hidden");
      handles.overlay.classList.add("hidden");
    };

    // Sign-in redirect
    handles.gmailButton.onclick = () => {
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider).catch(err => console.error("Popup sign-in error:", err));
    };

    // 1) redirect result
    try {
      const result = await getRedirectResult(auth);
      if (result?.user) {
        return handleSignedIn(result.user, handles);
      }
    } catch (e) {
      console.error(e);
    }

    // 2) existing session
    if (auth.currentUser) {
      return handleSignedIn(auth.currentUser, handles);
    }

    // 3) fallback listener
    onAuthStateChanged(auth, (user) => {
      if (user) return handleSignedIn(user, handles);
      handleSignedOut(handles);
    });
  });
} else if (currentPage === '/contentMgmt.html') {
  // --- Generic file-preview + upload wiring ---
  function wireFileInput({ inputId, previewId, page, photoID, fnKey }) {
    const fileInput = document.getElementById(inputId);
    const preview = document.getElementById(previewId);

    // Preview
    fileInput.addEventListener("change", e => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        preview.src = reader.result;
        preview.classList.remove("hidden");
      };
      reader.readAsDataURL(file);
    });

    // Upload
    const btn = document.querySelector(`[data-upload="${inputId}"]`);
    if (btn) {
      btn.addEventListener("click", async () => {
        handles.functionLoader.classList.remove("hidden");
        const file = fileInput.files[0];
        const toBase64 = file => new Promise(res => {
          const rd = new FileReader();
          rd.onloadend = () => res(rd.result);
          rd.readAsDataURL(file);
        });
        const base64 = await toBase64(file);
        const fn = httpsCallable(functions, window.goodKeys.get(fnKey));
        await fn({ image: base64, fileName: file.name, fileType: file.type, page, photoID });
        handles.functionLoader.classList.add("hidden");
      });
    }
  }

  // --- Tabs wiring ---
  function initTabs() {
    const tabs = document.querySelectorAll(".tablinks");
    const panels = document.querySelectorAll(".tabcontent");

    tabs.forEach(btn => {
      btn.addEventListener("click", () => {
        panels.forEach(p => p.classList.add("hidden"));
        tabs.forEach(b => b.classList.remove("active"));
        const tgt = document.getElementById(btn.dataset.tab);
        tgt.classList.remove("hidden");
        btn.classList.add("active");
      });
    });

    tabs[0]?.click();
  }

  function uploadImage(page, photoID) {
    runWithModal(async () => {
      // grab the file
      const input = document.getElementById(`file-${photoID}`);
      if (!input || !input.files.length) {
        throw new Error("Please select a file first.");
      }
      const file = input.files[0];

      // convert to base64
      const toBase64 = f => new Promise(res => {
        const rd = new FileReader();
        rd.onloadend = () => res(rd.result);
        rd.readAsDataURL(f);
      });
      const base64 = await toBase64(file);

      // call your upload CF
      const fn = httpsCallable(functions, window.goodKeys.get("runFunction1"));
      await fn({
        image: base64,
        fileName: file.name,
        fileType: file.type,
        page,
        photoID
      });


    }, {
      loadingMsg: "Uploading image…",
      loadingTitle: "Uploading",
      loadingColor: "blue",
      successMsg: "Image uploaded!",
      successTitle: "Success",
      successColor: "green",
      errorColor: "red"
    });
  }

  function uploadCarouselImage(page, photoID) {
    runWithModal(
      async () => {
        // 1️⃣ grab the file
        const input = document.getElementById(`file-${photoID}`);
        if (!input || !input.files.length) {
          throw new Error("Please select a file first.");
        }
        const file = input.files[0];

        // 2️⃣ to base64
        const toBase64 = f => new Promise(r => {
          const rd = new FileReader();
          rd.onloadend = () => r(rd.result);
          rd.readAsDataURL(f);
        });
        const base64 = await toBase64(file);

        // 3️⃣ call your CF
        const fn = httpsCallable(functions, window.goodKeys.get("runFunction4"));
        return fn({
          image: base64,
          fileName: file.name,
          fileType: file.type,
          page,
          photoID
        });
      },
      {
        loadingMsg: "Uploading to carousel…",
        loadingTitle: "Uploading",
        loadingColor: "blue",
        successMsg: "Photo added to carousel!",
        successTitle: "Done",
        successColor: "green",
        errorColor: "red"
      }
    );
  }

  // --- Render Home panel & wire its controls ---
  function renderHomePanel() {
    const root = document.getElementById("homePanel");
    const welcomeFields = [
      { id: "helloAndwelcomeTitle", label: "Welcome Title" },
      { id: "helloWelcomeText", label: "Welcome Content" },
      { id: "homePageServicesText", label: "Services Content" },
      { id: "homePageAtmoshpereText", label: "Atmosphere Content" },
      { id: "homePageYourBlessingText", label: "Your Lil Blessing" },
    ];

    const welcomeStaticHTML = welcomeFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const genderFields = [
      { id: "gDeterTitle", label: "Gender Determination Title" },
      { id: "gDeterParagraph", label: "Gender Determination Content" },
      { id: "ugd1", label: "Ultrasound Gender Dropdown" },
      { id: "sedgd1", label: "Sneak-peak DNA Gender Dropdown" },
    ];

    const genderStaticHTML = genderFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const wmuFields = [
      { id: "wmuTitle1", label: "What Makes Us Different Title 1" },
      { id: "wmuTitle2", label: "What Makes Us Different Title 2" },
      { id: "wmuTitle3", label: "What Makes Us Different Title 3" },
      { id: "homePageLiveUltraSoundsText", label: "What Makes Us Different Content" },
    ];

    const wmuHTML = wmuFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const bogFields = [
      { id: "boyOrGirlHeader", label: "Boy Or Girl Title 1" },
      { id: "boyOrGirlHeader2", label: "Boy Or Girl Title 2" },
      { id: "homePageGenderDetermText", label: "Boy Or Girl Content" },
    ];

    const bogHTML = bogFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const babyStreamFields = [
      { id: "babyStreamTitle1", label: "Baby Stream Live Title" },
      { id: "babyStreamTitle2", label: "Baby Stream Live Title 2" },
      { id: "homePageBabyStreamText", label: "Baby Stream Live Content" },
    ];

    const babyStreamHTML = babyStreamFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const hoursFields = [
      { id: "hoursText", label: "Hours Content" },
      { id: "hourFooter", label: "Hours Footer" },
    ];

    const hoursHTML = hoursFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    root.innerHTML = `
      <div class="w3-container w3-center w3-round-xxlarge w3-border
                  w3-bottombar w3-leftbar w3-topbar w3-rightbar w3-border-white w3-margin-64">
        <h3>Update Home Page</h3>
  
        <!-- Main Background Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Main Background</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-home" accept="image/*">
                <br>
                <img id="preview-home" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-home" data-page="home" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Main Background</h1>
              <img id="home" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Main Background (Small Screen) Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Main (Small Screens) Background</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-home-mobile" accept="image/*">
                <br>
                <img id="preview-home-mobile" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-home-mobile" data-page="home" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Main (Small Screens) Background</h1>
              <img id="home-mobile" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Background Award Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Background Award</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-award" accept="image/*">
                <br>
                <img id="preview-award" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-award" data-page="home" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Background Award</h1>
              <img id="award" class="w3-margin img-half">
            </div>
          </div>
        </div>
  
        <!-- Welcome Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding">
              <h1>Welcome Section</h1>
              <div class="w3-container w3-left-align">
                
                ${[
        { label: "Welcome Title", id: "helloAndwelcomeTitle", fnKey: "runFunction3" },
        { label: "Welcome Content", id: "helloWelcomeText", fnKey: "runFunction3", textarea: true },
        { label: "Services Content", id: "homePageServicesText", fnKey: "runFunction3", textarea: true },
        { label: "Atmoshpere Content", id: "homePageAtmoshpereText", fnKey: "runFunction3", textarea: true },
        { label: "Lil’ Blessing Content", id: "homePageYourBlessingText", fnKey: "runFunction3", textarea: true }
      ].map(field => `
                  <div>
                    <h2>Update ${field.label}</h2>
                    <div>
                      <label for="${field.id}">${field.label}:</label>
                      ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                      <br>
                      <button data-text-update="${field.id}" class="w3-green w3-right-align">
                        Update ${field.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
  
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding">
              <h1>Current Welcome Section</h1>
              <div class="w3-container">
                ${welcomeStaticHTML}
              </div>
            </div>
          </div>
        </div>
  
        <!-- Gender Determination Paragraph -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Gender Determination Paragraph</h1>
              <div class="w3-container w3-left-align">
                ${[
        { label: "Title", id: "gDeterTitle" },
        { label: "Content", id: "gDeterParagraph", textarea: true },
        { label: "Dropdown 1", id: "ugd1", textarea: true },
        { label: "Dropdown 2", id: "sedgd1", textarea: true },
      ].map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      ${f.textarea
          ? `<textarea id="${f.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${f.id}">`}
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Gender Determination Paragraph</h1>
              <div class="w3-container">
                ${genderStaticHTML}
              </div>
            </div>
          </div>
        </div>
  
        <!-- Gender Determination Photo -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Gender Determination Photo</h1>
              <h2>Upload an Image</h2>
              <input type="file" id="file-genderDeterminSectionPic" accept="image/*">
              <br>
              <img id="preview-genderDeterminSectionPic" class="w3-image w3-margin hidden max-preview visible">
              <br>
              <button data-upload="file-genderDeterminSectionPic" data-page="home" class="w3-btn w3-green">
                Upload
              </button>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Gender Determination Photo</h1>
              <img id="genderDeterminSectionPic" class="w3-margin img-half">
            </div>
          </div>
        </div>
        
        <!-- What Makes Us Different Paragraph -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>What Makes Us Different Paragraph</h1>
              <div class="w3-container w3-left-align">
                ${[
        { label: "Title 1", id: "wmuTitle1" },
        { label: "Title 2", id: "wmuTitle2" },
        { label: "Title 3", id: "wmuTitle3" },
        { label: "Content", id: "homePageLiveUltraSoundsText", textarea: true }
      ].map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    ${f.textarea
          ? `<textarea id="${f.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${f.id}">`}
                    <br>
                    <button data-text-update="${f.id}" class="w3-green w3-right-align">
                      Update ${f.label}
                    </button>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current What Makes Us Different Paragraph</h1>
              <div class="w3-container">
                ${wmuHTML}
              </div>
            </div>
          </div>
        </div>
  
        <!-- What Makes Us Different Photo -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update What Makes Us Different Photo</h1>
              <input type="file" id="file-liveUltraSoundPic" accept="image/*">
              <br>
              <img id="preview-liveUltraSoundPic" class="w3-image w3-margin hidden max-preview visible">
              <br>
              <button data-upload="file-liveUltraSoundPic" data-page="home" class="w3-btn w3-green">Upload</button>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current What Makes Us Different Photo</h1>
              <img id="liveUltraSoundPic" class="w3-margin img-half">
            </div>
          </div>
        </div>
  
        <!-- Boy or Girl Photo -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Boy or Girl Photo</h1>
              <input type="file" id="file-genderDetermPic" accept="image/*">
              <br>
              <img id="preview-genderDetermPic" class="w3-image w3-margin hidden max-preview visible">
              <br>
              <button data-upload="file-genderDetermPic" data-page="home" class="w3-btn w3-green">Upload</button>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Boy or Girl Photo</h1>
              <img id="genderDetermPic" class="w3-margin img-half">
            </div>
          </div>
        </div>
  
        <!-- Boy or Girl Paragraph -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Boy or Girl Paragraph</h1>
              <div class="w3-container w3-left-align">
                ${[
        { label: "Title 1", id: "boyOrGirlHeader" },
        { label: "Title 2", id: "boyOrGirlHeader2" },
        { label: "Content", id: "homePageGenderDetermText", textarea: true }
      ].map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    ${f.textarea
          ? `<textarea id="${f.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${f.id}">`}
                    <br>
                    <button data-text-update="${f.id}" class="w3-green w3-right-align">
                      Update ${f.label}
                    </button>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Boy or Girl Paragraph</h1>
              <div class="w3-container">
                ${bogHTML}
              </div>
            </div>
          </div>
        </div>
  
        <!-- Keepsakes Paragraph & Photo -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Keepsakes For Life Paragraph</h1>
              <div class="w3-container w3-left-align">
                ${[
        { label: "Title 1", id: "keepsakesTitle1" },
        { label: "Title 2", id: "keepsakesTitle2" },
        { label: "Content", id: "homePageHeartbeatText", textarea: true }
      ].map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    ${f.textarea
          ? `<textarea id="${f.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${f.id}">`}
                    <br>
                    <button data-text-update="${f.id}" class="w3-green w3-right-align">
                      Update ${f.label}
                    </button>
                  </div>
                `).join("")}
              </div>
              <div class="w3-padding-64">
                <h1>Update Keepsakes Photo</h1>
                <input type="file" id="file-heartBeatAnimalPic" accept="image/*">
                <br>
                <img id="preview-heartBeatAnimalPic" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-heartBeatAnimalPic" data-page="home" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Keepsakes For Life</h1>
              <h2>Title 1</h2><p id="keepsakesTitle1Display" class="w3-text-yellow w3-xlarge"></p>
              <h2>Title 2</h2><p id="keepsakesTitle2Display" class="w3-text-yellow w3-xlarge"></p>
              <h2>Content</h2><p id="homePageHeartbeatTextDisplay" class="w3-text-yellow w3-xlarge"></p>
              <h2>Photo</h2><img id="heartBeatAnimalPic" class="img-half">
            </div>
          </div>
        </div>

        <!-- Baby Stream Photo -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Baby Stream Photo</h1>
              <input type="file" id="file-babyStreamPic" accept="image/*">
              <br>
              <img id="preview-babyStreamPic" class="w3-image w3-margin hidden max-preview visible">
              <br>
              <button data-upload="file-babyStreamPic" data-page="home" class="w3-btn w3-green">Upload</button>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Baby Stream Photo</h1>
              <img id="babyStreamPic" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Baby Stream Paragraph -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Baby Stream Paragraph</h1>
              <div class="w3-container w3-left-align">
                ${[
        { label: "Title 1", id: "babyStreamTitle1" },
        { label: "Title 2", id: "babyStreamTitle2" },
        { label: "Content", id: "homePageBabyStreamText", textarea: true }
      ].map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    ${f.textarea
          ? `<textarea id="${f.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${f.id}">`}
                    <br>
                    <button data-text-update="${f.id}" class="w3-green w3-right-align">
                      Update ${f.label}
                    </button>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              ${babyStreamHTML}
            </div>
          </div>
        </div>
  
        <!-- Contact Section Photo -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Contact Section Photo</h1>
              <input type="file" id="file-contactSectPhoto" accept="image/*">
              <br>
              <img id="preview-contactSectPhoto" class="w3-image w3-margin hidden max-preview visible">
              <br>
              <button data-upload="file-contactSectPhoto" data-page="home" class="w3-btn w3-green">Upload</button>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Contact Section Photo</h1>
              <img id="contactSectPhoto" class="img-half">
            </div>
          </div>
        </div>

        <!-- Hours Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Hours</h1>
              <div class="w3-container w3-left-align">
                ${[
        { id: "hoursText", label: "Hours Content" },
        { id: "hourFooter", label: "Hours Footer" },
      ].map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    ${f.textarea
          ? `<textarea id="${f.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${f.id}">`}
                    <br>
                    <button data-text-update="${f.id}" class="w3-green w3-right-align">
                      Update ${f.label}
                    </button>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              ${hoursHTML}
            </div>
          </div>
        </div>
  
      </div>
    `;


    // wire file input for page="home", photoID="home", using runFunction1
    ["home",
      "home-mobile",
      "award",
      "genderDeterminSectionPic",
      "liveUltraSoundPic",
      "genderDetermPic",
      "heartBeatAnimalPic",
      "babyStreamPic",
      "contactSectPhoto",

      /* … etc … */
    ].forEach(id => {
      wireFileInput({
        inputId: `file-${id}`,
        previewId: `preview-${id}`,
        page: "home",
        photoID: id,
        fnKey: "runFunction1"
      });
    });

    // 2) Wire all your “Upload” buttons (they have data-upload="file‑id")
    document.querySelectorAll("[data-upload]").forEach(btn => {
      btn.addEventListener("click", () => {
        const photoID = btn.dataset.upload.replace("file-", "");
        const page = btn.dataset.page;
        uploadImage(page, photoID);
      });
    });

    // 3) Wire all your text‑update buttons (they have data-text-update="field‑id")
    document.querySelectorAll("[data-text-update]").forEach(btn => {
      btn.addEventListener("click", () => {
        const fieldId = btn.dataset.textUpdate;
        const newValue = document.getElementById(fieldId).value;
        runWithModal(async () => {
          const fn = httpsCallable(functions, window.goodKeys.get("runFunction3"));
          return fn({ updates: { [fieldId]: newValue } });
        }, {
          loadingMsg: "Updating text…",
          loadingTitle: "Updating",
          loadingColor: "khaki",
          successMsg: "Text updated!",
          successTitle: "Success",
          successColor: "green"
        });
      });
    });

    // set up real‑time listeners for all those text fields
    onSnapshot(doc(db, "textMappings", "publicText"), snap => {
      const data = snap.data()?.texts || {};
      Object.keys(data).forEach(key => {
        const disp = document.getElementById(key + "Display");
        const input = document.getElementById(key);
        if (disp) disp.innerText = data[key];
        if (input) input.value = data[key];
      });
    });


  }

  // --- Render Studio panel & wire its controls ---
  function renderStudioPanel() {
    const root = document.getElementById("studioPanel");

    const studioWelcomeFields = [
      { id: "studioMainTitle", label: "Welcome Title" },
      { id: "studioMainParagraph", label: "Studio Main Paragraph" },
      { id: "studioSecondParagraph", label: "2nd Paragraph" },
    ];

    const studioWelcomeStaticHTML = studioWelcomeFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    root.innerHTML = `
      <div class="w3-container w3-margin-top">
  
        <!-- ▶ Banner Image Section ▶ -->
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Studio Background</h4>
            <input type="file" id="file-studioHome" accept="image/*">
            <br><br>
            <img id="preview-studioHome" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-studioHome" data-page="studio" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Background</h4>
            <img id="studioHome" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Studio (Small Screen) Background</h4>
            <input type="file" id="file-studioHome-mobile" accept="image/*">
            <br><br>
            <img id="preview-studioHome-mobile" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-studioHome-mobile" data-page="studio" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Studio (Small Screens) Background</h4>
            <img id="studioHome-mobile" class="w3-image w3-margin w3-half">
          </div>
        </div>
  
        <!-- ▶ Studio Description Section ▶ -->
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Update Studio Description</h4>
            <div class="w3-container w3-left-align">
              ${[
        { label: "Welcome Title", id: "studioMainTitle", fnKey: "runFunction3" },
        { label: "Studio Main Paragraph", id: "studioMainParagraph", fnKey: "runFunction3", textarea: true },
        { label: "2nd Paragraph", id: "studioSecondParagraph", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current Studio Description</h4>
            <div class="w3-container">
              ${studioWelcomeStaticHTML}
            </div>
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload 2nd Paragraph Pic</h4>
            <input type="file" id="file-mainStudioPhoto" accept="image/*">
            <br><br>
            <img id="preview-mainStudioPhoto" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-mainStudioPhoto" data-page="studio" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current 2nd Paragraph Pic</h4>
            <img id="mainStudioPhoto" class="w3-image w3-margin w3-half">
          </div>
        </div>
  
        <!-- ▶ Carousel of Other Studio Photos ▶ -->
        <div class="w3-row-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload New Studio Photo</h4>
            <input type="file" id="file-studioCarouselFiles" accept="image/*">
            <br><br>
            <img id="preview-studioCarouselFiles" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-carousel-upload="file-studioCarouselFiles" class="w3-btn w3-green">Upload Photo</button>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Existing Studio Photos</h4>
            <div id="studioCarousel"></div>
          </div>
        </div>
      </div>
    `;
    const carouselInput = document.getElementById("file-studioCarouselFiles");
    const carouselPreview = document.getElementById("preview-studioCarouselFiles");
    carouselInput.addEventListener("change", e => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        carouselPreview.src = reader.result;
        carouselPreview.classList.remove("hidden");
      };
      reader.readAsDataURL(file);
    });

    ["studioHome",
      "studioHome-mobile",
      "mainStudioPhoto",
    ].forEach(id => {
      wireFileInput({
        inputId: `file-${id}`,
        previewId: `preview-${id}`,
        page: "studio",
        photoID: id,
        fnKey: "runFunction1"
      });
    });

    // 2) Wire all your “Upload” buttons (they have data-upload="file‑id")
    document.querySelectorAll("[data-upload]").forEach(btn => {
      btn.addEventListener("click", () => {
        const photoID = btn.dataset.upload.replace("file-", "");
        const page = btn.dataset.page;
        uploadImage(page, photoID);
      });
    });

    document.querySelectorAll("[data-carousel-upload]").forEach(btn => {
      btn.addEventListener("click", () => {
        const inputId = btn.dataset.carouselUpload;
        const photoID = inputId.replace("file-", "");
        const page = "studio";
        uploadCarouselImage(page, photoID);
      });
    });

    // 3) Wire all your text‑update buttons (they have data-text-update="field‑id")
    document.querySelectorAll("[data-text-update]").forEach(btn => {
      btn.addEventListener("click", () => {
        const fieldId = btn.dataset.textUpdate;
        const newValue = document.getElementById(fieldId).value;
        runWithModal(async () => {
          const fn = httpsCallable(functions, window.goodKeys.get("runFunction3"));
          return fn({ updates: { [fieldId]: newValue } });
        }, {
          loadingMsg: "Updating text…",
          loadingTitle: "Updating",
          loadingColor: "khaki",
          successMsg: "Text updated!",
          successTitle: "Success",
          successColor: "green"
        });
      });
    });

    // set up real‑time listeners for all those text fields
    onSnapshot(doc(db, "textMappings", "publicText"), snap => {
      const data = snap.data()?.texts || {};
      Object.keys(data).forEach(key => {
        const disp = document.getElementById(key + "Display");
        const input = document.getElementById(key);
        if (disp) disp.innerText = data[key];
        if (input) input.value = data[key];
      });
    });
  }

  // --- Render Prices panel & wire its controls ---
  function renderPricesPanel() {
    const root = document.getElementById("pricesPanel");

    const priceWelcomeTextFields = [
      { id: "pricePageTitle1", label: "Price Welcome Title 1" },
      { id: "pricePageTitle2", label: "Price Welcome Title 2" },
      { id: "pricePageIntro", label: "Price Page Intro" },
    ];

    const priceWelcomeStaticHTML = priceWelcomeTextFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const priceSlot1Fields = [
      { id: "priceSlot1Title", label: "Price Slot 1 Title" },
      { id: "priceSlot1Price", label: "Slot 1 Price" },
    ];

    const priceSlot1StaticHTML = priceSlot1Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const priceSlot1BulletsHTML = `
      <ul id="bullets-priceSlot1" class="w3-ul"></ul>
      <div class="w3-margin-top">
        <input type="text" id="bulletInput-priceSlot1" placeholder="New bullet…">
        <button data-bullet-add="priceSlot1" class="w3-button w3-small w3-yellow">Add to Bullets</button>
      </div>
    `;

    const priceSlot2Fields = [
      { id: "priceSlot2Title", label: "Price Slot 2 Title" },
      { id: "priceSlot2Price", label: "Slot 2 Price" },
    ];

    const priceSlot2StaticHTML = priceSlot2Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const priceSlot2BulletsHTML = `
      <ul id="bullets-priceSlot2" class="w3-ul"></ul>
      <div class="w3-margin-top">
        <input type="text" id="bulletInput-priceSlot2" placeholder="New bullet…">
        <button data-bullet-add="priceSlot2" class="w3-button w3-small w3-yellow">Add to Bullets</button>
      </div>
    `;

    const priceSlot3Fields = [
      { id: "priceSlot3Title", label: "Price Slot 3 Title" },
      { id: "priceSlot3Price", label: "Slot 3 Price" },
    ];

    const priceSlot3StaticHTML = priceSlot3Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const priceSlot3BulletsHTML = `
      <ul id="bullets-priceSlot3" class="w3-ul"></ul>
      <div class="w3-margin-top">
        <input type="text" id="bulletInput-priceSlot3" placeholder="New bullet…">
        <button data-bullet-add="priceSlot3" class="w3-button w3-small w3-yellow">Add to Bullets</button>
      </div>
    `;

    const priceSlot4Fields = [
      { id: "priceSlot4Title", label: "Price Slot 4 Title" },
      { id: "priceSlot4Price", label: "Slot 4 Price" },
    ];

    const priceSlot4StaticHTML = priceSlot4Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const priceSlot4BulletsHTML = `
      <ul id="bullets-priceSlot4" class="w3-ul"></ul>
      <div class="w3-margin-top">
        <input type="text" id="bulletInput-priceSlot4" placeholder="New bullet…">
        <button data-bullet-add="priceSlot4" class="w3-button w3-small w3-yellow">Add to Bullets</button>
      </div>
    `;

    const priceSlot5Fields = [
      { id: "priceSlot5Title", label: "Price Slot 5 Title" },
      { id: "priceSlot5Price", label: "Slot 5 Price" },
    ];

    const priceSlot5StaticHTML = priceSlot5Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const priceSlot5BulletsHTML = `
      <ul id="bullets-priceSlot5" class="w3-ul"></ul>
      <div class="w3-margin-top">
        <input type="text" id="bulletInput-priceSlot5" placeholder="New bullet…">
        <button data-bullet-add="priceSlot5" class="w3-button w3-small w3-yellow">Add to Bullets</button>
      </div>
    `;

    const priceSlot6Fields = [
      { id: "priceSlot6Title", label: "Price Slot 6 Title" },
      { id: "priceSlot6Price", label: "Slot 6 Price" },
    ];

    const priceSlot6StaticHTML = priceSlot6Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const priceSlot6BulletsHTML = `
      <ul id="bullets-priceSlot6" class="w3-ul"></ul>
      <div class="w3-margin-top">
        <input type="text" id="bulletInput-priceSlot6" placeholder="New bullet…">
        <button data-bullet-add="priceSlot6" class="w3-button w3-small w3-yellow">Add to Bullets</button>
      </div>
    `;

    const disclaimerFields = [
      { id: "priceDisclaimer", label: "Price Disclaimer" },
      { id: "priceDisclaimer2", label: "Price Disclaimer 2" },
    ];

    const disclaimerStaticHTML = disclaimerFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    root.innerHTML = `
      <div class="w3-container w3-center w3-round-xxlarge w3-border w3-bottombar w3-leftbar w3-topbar w3-rightbar w3-border-white w3-margin-64">
        <h3>Update Price Page</h3>

        <!-- Main Price Background Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Main Price Background</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-pricesBkgrd" accept="image/*">
                <br>
                <img id="preview-pricesBkgrd" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-pricesBkgrd" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Main Background</h1>
              <img id="pricesBkgrd" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Main Price Background Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Main Price (Small Screen) Background</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-pricesBkgrd-mobile" accept="image/*">
                <br>
                <img id="preview-pricesBkgrd-mobile" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-pricesBkgrd-mobile" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Price (Small Screens) Background</h1>
              <img id="pricesBkgrd-mobile" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding">
              <h1>Welcome Section</h1>
              <div class="w3-container w3-left-align">
                
                ${[
        { label: "Price Welcome Title 1", id: "pricePageTitle1", fnKey: "runFunction3" },
        { label: "Price Welcome Title 2", id: "pricePageTitle2", fnKey: "runFunction3", },
        { label: "Price Page Intro", id: "pricePageIntro", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                  <div>
                    <h2>Update ${field.label}</h2>
                    <div>
                      <label for="${field.id}">${field.label}:</label>
                      ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                      <br>
                      <button data-text-update="${field.id}" class="w3-green w3-right-align">
                        Update ${field.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
  
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding">
              <h1>Current Welcome Section</h1>
              <div class="w3-container">
                ${priceWelcomeStaticHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Price Slot 1 Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 1 Price</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-priceSlot1Img" accept="image/*">
                <br>
                <img id="preview-priceSlot1Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-priceSlot1Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Slot 1 Image</h1>
              <img id="priceSlot1Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Price Slot 1 Text Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 1 Price Text</h1>
              <div class="w3-container w3-left-align">
                ${priceSlot1Fields.map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      <label for="${f.id}">${f.label}:</label>
                      <input type="text" id="${f.id}">
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Slot 1 Price Text</h1>
              <div class="w3-container">
                ${priceSlot1StaticHTML}
                ${priceSlot1BulletsHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Price Slot 2 Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 2 Price</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-priceSlot2Img" accept="image/*">
                <br>
                <img id="preview-priceSlot2Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-priceSlot2Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Slot 2 Image</h1>
              <img id="priceSlot2Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Price Slot 2 Text Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 2 Price Text</h1>
              <div class="w3-container w3-left-align">
                ${priceSlot2Fields.map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      <label for="${f.id}">${f.label}:</label>
                      <input type="text" id="${f.id}">
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Slot 2 Price Text</h1>
              <div class="w3-container">
                ${priceSlot2StaticHTML}
                ${priceSlot2BulletsHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Price Slot 3 Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 3 Price</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-priceSlot3Img" accept="image/*">
                <br>
                <img id="preview-priceSlot3Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-priceSlot3Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Slot 3 Image</h1>
              <img id="priceSlot3Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Price Slot 3 Text Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 3 Price Text</h1>
              <div class="w3-container w3-left-align">
                ${priceSlot3Fields.map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      <label for="${f.id}">${f.label}:</label>
                      <input type="text" id="${f.id}">
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Slot 3 Price Text</h1>
              <div class="w3-container">
                ${priceSlot3StaticHTML}
                ${priceSlot3BulletsHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Price Slot 4 Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 4 Price</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-priceSlot4Img" accept="image/*">
                <br>
                <img id="preview-priceSlot4Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-priceSlot4Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Slot 4 Image</h1>
              <img id="priceSlot4Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Price Slot 4 Text Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 4 Price Text</h1>
              <div class="w3-container w3-left-align">
                ${priceSlot4Fields.map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      <label for="${f.id}">${f.label}:</label>
                      <input type="text" id="${f.id}">
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Slot 4 Price Text</h1>
              <div class="w3-container">
                ${priceSlot4StaticHTML}
                ${priceSlot4BulletsHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Price Slot 5 Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 5 Price</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-priceSlot5Img" accept="image/*">
                <br>
                <img id="preview-priceSlot5Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-priceSlot5Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Slot 5 Image</h1>
              <img id="priceSlot5Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Price Slot 5 Text Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 5 Price Text</h1>
              <div class="w3-container w3-left-align">
                ${priceSlot5Fields.map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      <label for="${f.id}">${f.label}:</label>
                      <input type="text" id="${f.id}">
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Slot 5 Price Text</h1>
              <div class="w3-container">
                ${priceSlot5StaticHTML}
                ${priceSlot5BulletsHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Price Slot 6 Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 6 Price</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-priceSlot6Img" accept="image/*">
                <br>
                <img id="preview-priceSlot6Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-priceSlot6Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Slot 6 Image</h1>
              <img id="priceSlot6Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Price Slot 6 Text Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Slot 6 Price Text</h1>
              <div class="w3-container w3-left-align">
                ${priceSlot6Fields.map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      <label for="${f.id}">${f.label}:</label>
                      <input type="text" id="${f.id}">
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Slot 6 Price Text</h1>
              <div class="w3-container">
                ${priceSlot6StaticHTML}
                ${priceSlot6BulletsHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Disclaimer Text Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Disclaimer Text</h1>
              <div class="w3-container w3-left-align">
                ${[
        { id: "priceDisclaimer", label: "Price Disclaimer", fnKey: "runFunction3" },
        { id: "priceDisclaimer2", label: "Price Disclaimer 2", fnKey: "runFunction3" },
      ].map(f => `
                  <div>
                    <h2>Update ${f.label}</h2>
                    <div>
                      <label for="${f.id}">${f.label}:</label>
                      <input type="text" id="${f.id}">
                      <br>
                      <button data-text-update="${f.id}" class="w3-green w3-right-align">
                        Update ${f.label}
                      </button>
                    </div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64">
              <h1>Current Disclaimer Text</h1>
              <div class="w3-container">
                ${disclaimerStaticHTML}
              </div>
            </div>
          </div>
        </div>

        <!-- Discount Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Discount Image</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-discountImg" accept="image/*">
                <br>
                <img id="preview-discountImg" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-discountImg" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Slot 1 Image</h1>
              <img id="discountImg" class="w3-margin img-half">
            </div>
          </div>
        </div>

        

        <!-- Heartbeat Animal Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Heartbeat 1 Image</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-hbAnimal1Img" accept="image/*">
                <br>
                <img id="preview-hbAnimal1Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-hbAnimal1Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Heartbeat Animal 1 Image</h1>
              <img id="hbAnimal1Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Heartbeat Animal Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Heartbeat 2 Image</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-hbAnimal2Img" accept="image/*">
                <br>
                <img id="preview-hbAnimal2Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-hbAnimal2Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Heartbeat Animal 2 Image</h1>
              <img id="hbAnimal2Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Heartbeat Animal Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Heartbeat 3 Image</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-hbAnimal3Img" accept="image/*">
                <br>
                <img id="preview-hbAnimal3Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-hbAnimal3Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Heartbeat Animal 3 Image</h1>
              <img id="hbAnimal3Img" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <!-- Heartbeat Animal Image Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Heartbeat 4 Image</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-hbAnimal4Img" accept="image/*">
                <br>
                <img id="preview-hbAnimal4Img" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-hbAnimal4Img" data-page="prices" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Heartbeat Animal 4 Image</h1>
              <img id="hbAnimal4Img" class="w3-margin img-half">
            </div>
          </div>
        </div>
      </div>
    `;

    // wire file input for page="home", photoID="home", using runFunction1
    ["pricesBkgrd",
      "pricesBkgrd-mobile",
      "priceSlot1Img",
      "priceSlot2Img",
      "priceSlot3Img",
      "priceSlot4Img",
      "priceSlot5Img",
      "priceSlot6Img",
      "discountImg",
      "hbAnimal1Img",
      "hbAnimal2Img",
      "hbAnimal3Img",
      "hbAnimal4Img",
      /* Add other IDs as needed */

      /* … etc … */
    ].forEach(id => {
      wireFileInput({
        inputId: `file-${id}`,
        previewId: `preview-${id}`,
        page: "prices",
        photoID: id,
        fnKey: "runFunction1"
      });
    });

    // 2) Wire all your “Upload” buttons (they have data-upload="file‑id")
    document.querySelectorAll("[data-upload]").forEach(btn => {
      btn.addEventListener("click", () => {
        const photoID = btn.dataset.upload.replace("file-", "");
        const page = btn.dataset.page;
        uploadImage(page, photoID);
      });
    });

    // 3) Wire all your text‑update buttons (they have data-text-update="field‑id")
    document.querySelectorAll("[data-text-update]").forEach(btn => {
      btn.addEventListener("click", () => {
        const fieldId = btn.dataset.textUpdate;
        const newValue = document.getElementById(fieldId).value;
        runWithModal(async () => {
          const fn = httpsCallable(functions, window.goodKeys.get("runFunction3"));
          return fn({ updates: { [fieldId]: newValue } });
        }, {
          loadingMsg: "Updating text…",
          loadingTitle: "Updating",
          loadingColor: "khaki",
          successMsg: "Text updated!",
          successTitle: "Success",
          successColor: "green"
        });
      });
    });

    // set up real‑time listeners for all those text fields
    onSnapshot(doc(db, "textMappings", "publicText"), snap => {
      const data = snap.data()?.texts || {};
      Object.keys(data).forEach(key => {
        const disp = document.getElementById(key + "Display");
        const input = document.getElementById(key);
        if (disp) disp.innerText = data[key];
        if (input) input.value = data[key];
      });
    });
  }

  function renderSneakPeek() {
    const root = document.getElementById("sneakPanel");

    const sneakpeekWelcomeFields = [
      { id: "sneakPeekMainText", label: "Main Text" },
      { id: "bloodDrawNote", label: "Blood Draw Note" },
    ];

    const sneakpeekSection2Fields = [
      { label: "Price Header", id: "sneakPeekPriceHeader", },
      { label: "Price Text 1", id: "sneakPeekPriceText1", },
      { label: "Price Text 2", id: "sneakPeekPriceText2", },
    ];

    const sneakPeekSection3Fields = [
      { label: "Community Header", id: "sneakPeakCommunityHeader", },
      { label: "Community Text", id: "sneakPeekCommunityText", }
    ];

    const sneakpeekStaticHTML = sneakpeekWelcomeFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const sneakpeekSection2StaticHTML = sneakpeekSection2Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const sneakpeekSection3StaticHTML = sneakPeekSection3Fields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    root.innerHTML = `
      <div class="w3-container w3-margin-top">
  
        <!-- ▶ Banner Image Section ▶ -->
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Sneak Peek Background</h4>
            <input type="file" id="file-sneakpeekHome" accept="image/*">
            <br><br>
            <img id="preview-sneakpeekHome" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-sneakpeekHome" data-page="sneakPeek" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Background</h4>
            <img id="sneakpeekHome" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <!-- ▶ Banner Image Section ▶ -->
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload SneakPeek (Small Screens) Background</h4>
            <input type="file" id="file-sneakpeekHome-mobile" accept="image/*">
            <br><br>
            <img id="preview-sneakpeekHome-mobile" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-sneakpeekHome-mobile" data-page="sneakPeek" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current SneakPeek (Small Screens) Background</h4>
            <img id="sneakpeekHome-mobile" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Sneak Peak Logo Pic</h4>
            <input type="file" id="file-sneakPeakMainPic" accept="image/*">
            <br><br>
            <img id="preview-sneakPeakMainPic" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-sneakPeakMainPic" data-page="sneakPeek" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Sneak Peak Logo Pic</h4>
            <img id="sneakPeakMainPic" class="w3-image w3-margin w3-half">
          </div>
        </div>
  
        <!-- ▶ SP Description Section ▶ -->
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Update Sneek Peak Description</h4>
            <div class="w3-container w3-left-align">
              ${[
        { label: "Sneak Peek Main Text", id: "sneakPeekMainText", fnKey: "runFunction3", textarea: true },
        { label: "Blood Draw Note", id: "bloodDrawNote", fnKey: "runFunction3", },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current Sneak Peek Description</h4>
            <div class="w3-container">
              ${sneakpeekStaticHTML}
            </div>
          </div>
        </div>

        <!-- ▶ SP Price Section ▶ -->
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Update Sneek Peek Price Section</h4>
            <div class="w3-container w3-left-align">
              ${[
        { label: "Price Header", id: "sneakPeekPriceHeader", fnKey: "runFunction3" },
        { label: "Price Text 1", id: "sneakPeekPriceText1", fnKey: "runFunction3", textarea: true },
        { label: "Price Text 2", id: "sneakPeekPriceText2", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                    </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current Sneak Peek Price Section</h4>
            <div class="w3-container">
              ${sneakpeekSection2StaticHTML}
            </div>
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Sneak Peak Pricing Pic</h4>
            <input type="file" id="file-bloodDrawVilePic" accept="image/*">
            <br><br>
            <img id="preview-bloodDrawVilePic" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-bloodDrawVilePic" data-page="sneakPeek" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Sneak Peak Pricing Pic</h4>
            <img id="bloodDrawVilePic" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Sneak Peak Community Pic</h4>
            <input type="file" id="file-sneakPeekCommunityPhoto" accept="image/*">
            <br><br>
            <img id="preview-sneakPeekCommunityPhoto" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-sneakPeekCommunityPhoto" data-page="sneakPeek" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Sneak Peak Community Pic</h4>
            <img id="sneakPeekCommunityPhoto" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <!-- ▶ SP Community Section ▶ -->
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Update Sneek Peek Community Section</h4>
            <div class="w3-container w3-left-align">
              ${[
        { label: "Community Header", id: "sneakPeakCommunityHeader", fnKey: "runFunction3" },
        { label: "Community Text", id: "sneakPeekCommunityText", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                    </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current Sneak Peek Community Section</h4>
            <div class="w3-container">
              ${sneakpeekSection3StaticHTML}
            </div>
          </div>
        </div>

        


      
      </div>
    `;

    ["sneakpeekHome",
      "sneakpeekHome-mobile",
      "sneakPeakMainPic",
      "bloodDrawVilePic",
      "sneakPeekCommunityPhoto",
    ].forEach(id => {
      wireFileInput({
        inputId: `file-${id}`,
        previewId: `preview-${id}`,
        page: "studio",
        photoID: id,
        fnKey: "runFunction1"
      });
    });

    // 2) Wire all your “Upload” buttons (they have data-upload="file‑id")
    document.querySelectorAll("[data-upload]").forEach(btn => {
      btn.addEventListener("click", () => {
        const photoID = btn.dataset.upload.replace("file-", "");
        const page = btn.dataset.page;
        uploadImage(page, photoID);
      });
    });

    // 3) Wire all your text‑update buttons (they have data-text-update="field‑id")
    document.querySelectorAll("[data-text-update]").forEach(btn => {
      btn.addEventListener("click", () => {
        const fieldId = btn.dataset.textUpdate;
        const newValue = document.getElementById(fieldId).value;
        runWithModal(async () => {
          const fn = httpsCallable(functions, window.goodKeys.get("runFunction3"));
          return fn({ updates: { [fieldId]: newValue } });
        }, {
          loadingMsg: "Updating text…",
          loadingTitle: "Updating",
          loadingColor: "khaki",
          successMsg: "Text updated!",
          successTitle: "Success",
          successColor: "green"
        });
      });
    });

    // set up real‑time listeners for all those text fields
    onSnapshot(doc(db, "textMappings", "publicText"), snap => {
      const data = snap.data()?.texts || {};
      Object.keys(data).forEach(key => {
        const disp = document.getElementById(key + "Display");
        const input = document.getElementById(key);
        if (disp) disp.innerText = data[key];
        if (input) input.value = data[key];
      });
    });
  }

  function renderGalleryPanel() {
    // Get references to our new Callable Functions
    const uploadPhotoMetadata = httpsCallable(functions, window.goodKeys.get("runFunction6"));
    const deletePhoto = httpsCallable(functions, window.goodKeys.get("runFunction7"));
    const reorderPhotos = httpsCallable(functions, window.goodKeys.get("runFunction8"));

    // DOM Elements (same as before)
    const uploadForm = document.getElementById('uploadForm');
    const photoFileInput = document.getElementById('photoFile');
    const categorySelect = document.getElementById('photoCategory');
    const captionInput = document.getElementById('photoCaption');
    const uploadProgress = document.getElementById('uploadProgress');
    const galleryContainer = document.getElementById('manage-gallery');

    // --- 1. UPLOAD LOGIC (REFACTORED) ---
    uploadForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const file = photoFileInput.files[0];
      const category = categorySelect.value;
      const caption = captionInput.value;

      if (!file || !category) {
        alert('Please select a file and a category.');
        return;
      }

      // The upload to Storage remains on the client
      const storagePath = `gallery-images/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, storagePath);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          uploadProgress.textContent = `Upload is ${progress.toFixed(2)}% done`;
        },
        (error) => {
          console.error("Upload failed:", error);
          alert("Upload failed. See console for details.");
        },
        async () => {
          // Upload complete, get download URL
          const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);

          // NOW, CALL THE BACKEND FUNCTION
          try {
            const result = await uploadPhotoMetadata({
              imageUrl: imageUrl,
              storagePath: storagePath,
              category: category,
              caption: caption
            });
            console.log(result.data.message);
            uploadProgress.textContent = 'Upload complete!';
            uploadForm.reset();
          } catch (error) {
            console.error("Error calling upload function:", error);
            alert(`Error: ${error.message}`);
          } finally {
            setTimeout(() => uploadProgress.textContent = '', 3000);
          }
        }
      );
    });

    // --- 2. DISPLAY LOGIC (NO CHANGE) ---
    // The real-time listener doesn't need to change at all. It will automatically
    // reflect the changes made by the backend functions.
    const q = query(collection(db, "galleryImages"), orderBy("order", "asc"));
    onSnapshot(q, (snapshot) => {
      galleryContainer.innerHTML = ''; // Clear current display
      snapshot.forEach(docSnap => {
        const photo = docSnap.data();
        const photoId = docSnap.id;

        const card = document.createElement('div');
        card.className = 'w3-col l3 m6 w3-margin-bottom';
        card.setAttribute('data-id', photoId); // Set data-id for reordering

        card.innerHTML = `
            <div class="w3-display-container">
                <div class="w3-display-topleft w3-black w3-padding">${photo.category}</div>
                <img src="${photo.imageUrl}" class="galleryImg">
                <div class="w3-display-bottomleft w3-container w3-padding w3-text-white galleryDisplayCaption">${photo.caption || 'No Caption'}</div>
                <button class="w3-button w3-red w3-display-topright delete-btn" data-id="${photoId}" data-path="${photo.storagePath}">×</button>
            </div>
        `;
        galleryContainer.appendChild(card);
      });
    });

    // --- 3. DELETE LOGIC (REFACTORED) ---
    galleryContainer.addEventListener('click', async (e) => {
      if (e.target.classList.contains('delete-btn')) {
        const docId = e.target.dataset.id;
        const storagePath = e.target.dataset.path;

        if (confirm('Are you sure you want to delete this photo?')) {
          try {
            // CALL THE BACKEND FUNCTION
            const result = await deletePhoto({ docId, storagePath });
            alert(result.data.message);
          } catch (error) {
            console.error("Error deleting photo:", error);
            alert(`Deletion failed: ${error.message}`);
          }
        }
      }
    });

    // --- 4. BONUS: REORDER LOGIC (REFACTORED) ---
    new Sortable(galleryContainer, {
      animation: 150,
      ghostClass: 'w3-opacity',
      onEnd: async (evt) => {
        const items = Array.from(galleryContainer.children);
        const orderedIds = items.map(item => item.getAttribute('data-id'));

        try {
          // CALL THE BACKEND FUNCTION
          const result = await reorderPhotos({ orderedIds });
          console.log(result.data.message);
        } catch (error) {
          console.error('Failed to update order:', error);
          alert(`Could not reorder photos: ${error.message}`);
        }
      }
    });
  }

  function renderFAQPanel() {
    const root = document.getElementById("faqPhotoSection");
    root.innerHTML = `
      <div class="w3-container w3-center w3-round-xxlarge w3-border
                    w3-bottombar w3-leftbar w3-topbar w3-rightbar w3-border-white w3-margin-64">
          <h3>Update FAQ Page</h3>
          <!-- Main Background Section -->
        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Main Background</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-faqHome" accept="image/*">
                <br>
                <img id="preview-faqHome" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-faqHome" data-page="faqHome" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Main Background</h1>
              <img id="faqHome" class="w3-margin img-half">
            </div>
          </div>
        </div>

        <div class="w3-row w3-padding">
          <div class="w3-half w3-pink w3-container w3-center">
            <div class="w3-padding-64">
              <h1>Update Main (Small Screens) Background</h1>
              <div class="w3-container">
                <h2>Upload an Image</h2>
                <input type="file" id="file-faqHome-mobile" accept="image/*">
                <br>
                <img id="preview-faqHome-mobile" class="w3-image w3-margin hidden max-preview visible">
                <br>
                <button data-upload="file-faqHome-mobile" data-page="faqHome" class="w3-btn w3-green">Upload</button>
              </div>
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <div class="w3-padding-64 w3-center">
              <h1>Current Main (Small Screens) Background</h1>
              <img id="faqHome-mobile" class="w3-margin img-half">
            </div>
          </div>
        </div>
      </div>
    `;

    // wire file input for page="home", photoID="home", using runFunction1
    ["faqHome",
      "faqHome-mobile",
    ].forEach(id => {
      wireFileInput({
        inputId: `file-${id}`,
        previewId: `preview-${id}`,
        page: "faq",
        photoID: id,
        fnKey: "runFunction1"
      });
    });

    // 2) Wire all your “Upload” buttons (they have data-upload="file‑id")
    document.querySelectorAll("[data-upload]").forEach(btn => {
      btn.addEventListener("click", () => {
        const photoID = btn.dataset.upload.replace("file-", "");
        const page = btn.dataset.page;
        uploadImage(page, photoID);
      });
    });

    // --- Cloud Function References ---
    const addFaq = httpsCallable(functions, window.goodKeys.get("runFunction9"));
    const updateFaq = httpsCallable(functions, window.goodKeys.get("runFunction10"));
    const deleteFaq = httpsCallable(functions, window.goodKeys.get("runFunction11"));
    const reorderFaqs = httpsCallable(functions, window.goodKeys.get("runFunction19"));

    // --- DOM Elements ---
    const form = document.getElementById('faq-form');
    const formTitle = document.getElementById('form-title');
    const faqIdInput = document.getElementById('faq-id');
    const questionInput = document.getElementById('question');
    const answerInput = document.getElementById('answer');
    const isSneakPeekInput = document.getElementById('isSneakPeek'); // NEW
    const cancelBtn = document.getElementById('cancel-edit-btn');
    const faqAdminList = document.getElementById('faq-admin-list');
    const saveOrderBtn = document.getElementById('save-order-btn'); //

    // --- State Management ---
    let editMode = false;

    // --- Reset Form Function ---
    const resetForm = () => {
      form.reset();
      faqIdInput.value = '';
      formTitle.textContent = 'Add New FAQ';
      cancelBtn.classList.add('w3-hide');
      editMode = false;
    };

    // --- Form Submission Handler ---
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const question = questionInput.value.trim();
      const answer = answerInput.value.trim();
      const id = faqIdInput.value;
      const isSneakPeek = isSneakPeekInput.checked;

      if (!question || !answer) return;

      try {
        if (editMode) {
          await updateFaq({ id, question, answer, isSneakPeek });
          alert('FAQ updated successfully!');
        } else {
          await addFaq({ question, answer, isSneakPeek });
          alert('FAQ added successfully!');
        }
        resetForm();
      } catch (error) {
        console.error('Error submitting form:', error);
        alert(`Error: ${error.message}`);
      }
    });

    // --- Cancel Edit Button ---
    cancelBtn.addEventListener('click', resetForm);

    // --- Render List (With Reorder Controls) ---
    const renderAdminList = (docs) => {
      if (docs.length === 0) {
        faqAdminList.innerHTML = "<p>No FAQs yet.</p>";
        return;
      }

      // Use an Ordered List so we can easily grab indices later
      let html = '<ul class="w3-ul w3-card-4 w3-white">';

      docs.forEach((doc, index) => {
        const faq = doc.data();

        // UI Badge for Sneak Peek
        const badge = faq.isSneakPeek
          ? '<span class="w3-tag w3-deep-purple w3-round w3-small w3-margin-left">Sneak Peek</span>'
          : "";

        html += `
                <li class="w3-bar w3-border-bottom" data-id="${doc.id}">
                    <div class="w3-bar-item w3-right">
                        <div class="w3-margin-bottom">
                            <button class="w3-button w3-tiny w3-light-grey w3-border move-up-btn" title="Move Up">⬆</button>
                            <button class="w3-button w3-tiny w3-light-grey w3-border move-down-btn" title="Move Down">⬇</button>
                        </div>
                        <div>
                            <button class="w3-button w3-small w3-blue edit-btn" data-id="${doc.id}">Edit</button>
                            <button class="w3-button w3-small w3-red delete-btn" data-id="${doc.id}">Delete</button>
                        </div>
                    </div>

                    <div class="w3-bar-item" style="max-width: 70%">
                        <span class="w3-large font-weight-bold">${faq.question}</span>
                        ${badge}
                        <br>
                        <span class="w3-text-grey text-truncate">${faq.answer.substring(0, 60)}...</span>
                    </div>
                    
                    <div class="w3-hide" id="data-${doc.id}" 
                        data-q="${faq.question}" 
                        data-a="${faq.answer}" 
                        data-peek="${faq.isSneakPeek}"></div>
                </li>
            `;
      });
      html += "</ul>";
      faqAdminList.innerHTML = html;
    };

    // --- List Click Handler (for Edit/Delete) ---
    faqAdminList.addEventListener("click", (e) => {
      const target = e.target;
      const li = target.closest("li");

      // 1. MOVE UP
      if (target.matches(".move-up-btn") && li.previousElementSibling) {
        li.parentNode.insertBefore(li, li.previousElementSibling);
        saveOrderBtn.classList.remove("w3-hide"); // Show Save Button
      }

      // 2. MOVE DOWN
      if (target.matches(".move-down-btn") && li.nextElementSibling) {
        li.parentNode.insertBefore(li.nextElementSibling, li);
        saveOrderBtn.classList.remove("w3-hide"); // Show Save Button
      }

      // 3. EDIT
      if (target.matches(".edit-btn")) {
        const id = target.dataset.id;
        const dataDiv = document.getElementById(`data-${id}`);

        editMode = true;
        formTitle.textContent = "Edit FAQ";
        cancelBtn.classList.remove("w3-hide");

        faqIdInput.value = id;
        questionInput.value = dataDiv.dataset.q;
        answerInput.value = dataDiv.dataset.a;
        // Convert string "true"/"false" back to boolean
        isSneakPeekInput.checked = dataDiv.dataset.peek === "true";

        window.scrollTo(0, 0);
      }

      // 4. DELETE
      if (target.matches(".delete-btn")) {
        const id = target.dataset.id;
        if (confirm("Delete this FAQ permanently?")) {
          deleteFaq({ id })
            .then(() => alert("Deleted."))
            .catch(console.error);
        }
      }
    });

    // --- SAVE NEW ORDER Logic ---
    saveOrderBtn.addEventListener("click", async () => {
      // 1. Get all list items in their CURRENT visual order
      const listItems = faqAdminList.querySelectorAll("li");
      const newOrderList = [];

      // 2. Build the array: [{id: "abc", order: 0}, {id: "xyz", order: 1}, ...]
      listItems.forEach((item, index) => {
        newOrderList.push({
          id: item.dataset.id,
          order: index,
        });
      });

      saveOrderBtn.textContent = "Saving...";
      saveOrderBtn.disabled = true;

      try {
        // 3. Send to Cloud Function
        await reorderFaqs({ newOrderList });
        alert("New order saved!");
        saveOrderBtn.classList.add("w3-hide");
      } catch (error) {
        console.error(error);
        alert("Error saving order.");
      } finally {
        saveOrderBtn.textContent = "💾 Save New Order";
        saveOrderBtn.disabled = false;
      }
    });


    // --- Auth Listener ---
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // Updated Query: Order by 'order' field
        const faqsCollection = collection(db, "faqs");
        const q = query(faqsCollection, orderBy("order", "asc"));
        onSnapshot(q, (snapshot) => renderAdminList(snapshot.docs));
      } else {
        faqAdminList.innerHTML = "<p>Please log in.</p>";
      }
    });
  }

  function renderGenderDeterminationPanel() {
    const root = document.getElementById("genderDeterPanel");

    const genderDetermineFields = [
      { id: "genderDeterminationMainText", label: "Main Text" },
    ];

    const genderDetermineFields2 = [
      { id: "genderDetermination2ndParagraph", label: "2nd Paragraph" },
    ];

    const genderDetermineFields3 = [
      { id: "genderDeterminationWTEHeader", label: "Paragraph 3 Header" },
      { id: "genderDeterminationWTEParagraph", label: "Paragraph 3 Text" },
    ];

    const genderDetermineFields4 = [
      { id: "genderDeterminationLastParagraph", label: "Last Paragraph" },
    ];

    const genderDetermStaticHTML = genderDetermineFields.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const genderDetermStaticHTML2 = genderDetermineFields2.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const genderDetermStaticHTML3 = genderDetermineFields3.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    const genderDetermStaticHTML4 = genderDetermineFields4.map(f => `
      <h2>${f.label}</h2>
      <p id="${f.id}Display" class="w3-text-yellow w3-xlarge"></p>
    `).join("");

    root.innerHTML = `
      <div class="w3-container w3-margin-top">
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Sneak Peek Background</h4>
            <input type="file" id="file-genderDetermineHome" accept="image/*">
            <br><br>
            <img id="preview-genderDetermineHome" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-genderDetermineHome" data-page="genderDeterm" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Background</h4>
            <img id="genderDetermineHome" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Sneak Peek (Small Screens) Background</h4>
            <input type="file" id="file-genderDetermineHome-mobile" accept="image/*">
            <br><br>
            <img id="preview-genderDetermineHome-mobile" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-genderDetermineHome-mobile" data-page="genderDeterm" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current (Small Screens) Background</h4>
            <img id="genderDetermineHome-mobile" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Gender Determination Pic 1</h4>
            <input type="file" id="file-genderDeterminationMainPic" accept="image/*">
            <br><br>
            <img id="preview-genderDeterminationMainPic" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-genderDeterminationMainPic" data-page="genderDeterm" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Gender Determination Pic 1</h4>
            <img id="genderDeterminationMainPic" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Update Gender Determination Paragraph 1</h4>
            <div class="w3-container w3-left-align">
              ${[
        { id: "genderDeterminationMainText", label: "Main Text", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current Gender Determination Paragraph 1 Description</h4>
            <div class="w3-container">
              ${genderDetermStaticHTML}
            </div>
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
          <h4>Update Gender Determination Paragraph 2</h4>
            <div class="w3-container w3-left-align">
              ${[
        { id: "genderDetermination2ndParagraph", label: "2nd Paragraph", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current Gender Determination Paragraph 2 Description</h4>
            <div class="w3-container">
              ${genderDetermStaticHTML2}
            </div>
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Gender Determination Pic 2</h4>
            <input type="file" id="file-genderDetermination2ndPic" accept="image/*">
            <br><br>
            <img id="preview-genderDetermination2ndPic" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-genderDetermination2ndPic" data-page="genderDeterm" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Gender Determination Pic 2</h4>
            <img id="genderDetermination2ndPic" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Gender Determination Pic 3</h4>
            <input type="file" id="file-whatToExpectPhoto" accept="image/*">
            <br><br>
            <img id="preview-whatToExpectPhoto" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-whatToExpectPhoto" data-page="genderDeterm" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Gender Determination Pic 3</h4>
            <img id="whatToExpectPhoto" class="w3-image w3-margin w3-half">
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
          <h4>Update What To Expect Paragraph</h4>
            <div class="w3-container w3-left-align">
              ${[
        { id: "genderDeterminationWTEHeader", label: "Paragraph 3 Header", fnKey: "runFunction3" },
        { id: "genderDeterminationWTEParagraph", label: "Paragraph 3 Text", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current What To Expect Paragraph</h4>
            <div class="w3-container">
              ${genderDetermStaticHTML3}
            </div>
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
          <h4>Update Paragraph 4 (Last Paragraph)</h4>
            <div class="w3-container w3-left-align">
              ${[
        { id: "genderDeterminationLastParagraph", label: "Last Paragraph", fnKey: "runFunction3", textarea: true },
      ].map(field => `
                <div>
                  <h2>Update ${field.label}</h2>
                  <div>
                    <label for="${field.id}">${field.label}:</label>
                    ${field.textarea
          ? `<textarea id="${field.id}" placeholder="Enter content"></textarea>`
          : `<input type="text" id="${field.id}">`}
                    <br>
                    <button data-text-update="${field.id}" class="w3-green w3-right-align">
                      Update ${field.label}
                    </button>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>
          <div class="w3-half w3-purple w3-container">
            <h4>Current Paragraph 4 (Last Paragraph)</h4>
            <div class="w3-container">
              ${genderDetermStaticHTML4}
            </div>
          </div>
        </div>

        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-half w3-pink w3-container w3-center">
            <h4>Upload Gender Determination Pic 4</h4>
            <input type="file" id="file-genderDetermination4thPic" accept="image/*">
            <br><br>
            <img id="preview-genderDetermination4thPic" class="w3-image hidden max-preview visible">
            <br><br>
            <button data-upload="file-genderDetermination4thPic" data-page="genderDeterm" class="w3-btn w3-green">
              Upload
            </button>
          </div>
          <div class="w3-half w3-purple w3-container w3-center">
            <h4>Current Gender Determination Pic 4</h4>
            <img id="genderDetermination4thPic" class="w3-image w3-margin w3-half">
          </div>
        </div>





      </div>
    `;

    ["genderDetermineHome",
      "genderDetermineHome-mobile",
      "genderDeterminationMainPic",
      "genderDetermination2ndPic",
      "whatToExpectPhoto",
      "genderDetermination4thPic",
    ].forEach(id => {
      wireFileInput({
        inputId: `file-${id}`,
        previewId: `preview-${id}`,
        page: "genderDeterm",
        photoID: id,
        fnKey: "runFunction1"
      });
    });

    // 2) Wire all your “Upload” buttons (they have data-upload="file‑id")
    document.querySelectorAll("[data-upload]").forEach(btn => {
      btn.addEventListener("click", () => {
        const photoID = btn.dataset.upload.replace("file-", "");
        const page = btn.dataset.page;
        uploadImage(page, photoID);
      });
    });

    // 3) Wire all your text‑update buttons (they have data-text-update="field‑id")
    document.querySelectorAll("[data-text-update]").forEach(btn => {
      btn.addEventListener("click", () => {
        const fieldId = btn.dataset.textUpdate;
        const newValue = document.getElementById(fieldId).value;
        runWithModal(async () => {
          const fn = httpsCallable(functions, window.goodKeys.get("runFunction3"));
          return fn({ updates: { [fieldId]: newValue } });
        }, {
          loadingMsg: "Updating text…",
          loadingTitle: "Updating",
          loadingColor: "khaki",
          successMsg: "Text updated!",
          successTitle: "Success",
          successColor: "green"
        });
      });
    });

    // set up real‑time listeners for all those text fields
    onSnapshot(doc(db, "textMappings", "publicText"), snap => {
      const data = snap.data()?.texts || {};
      Object.keys(data).forEach(key => {
        const disp = document.getElementById(key + "Display");
        const input = document.getElementById(key);
        if (disp) disp.innerText = data[key];
        if (input) input.value = data[key];
      });
    });

  }

  function renderSponsorsPanel() {
    // Implementation for Sponsors Panel goes here
    // --- Get Callable Function References ---
    const createSponsor = httpsCallable(functions, window.goodKeys.get("runFunction12"));
    const updateSponsor = httpsCallable(functions, window.goodKeys.get("runFunction13"));
    const deleteSponsor = httpsCallable(functions, window.goodKeys.get("runFunction14"));
    const reorderSponsors = httpsCallable(functions, window.goodKeys.get("runFunction15"));

    // --- DOM Elements ---
    const sponsorForm = document.getElementById('sponsorForm');
    const sponsorFormTitle = document.getElementById('sponsorFormTitle');
    const sponsorEditId = document.getElementById('sponsorEditId');
    const sponsorOldLogoPath = document.getElementById('sponsorOldLogoPath');
    const sponsorNameInput = document.getElementById('sponsorName');
    const sponsorWebsiteInput = document.getElementById('sponsorWebsite');
    const sponsorLogoInput = document.getElementById('sponsorLogo');
    const sponsorUploadProgress = document.getElementById('sponsorUploadProgress');
    const sponsorFacebookInput = document.getElementById('sponsorFacebook');
    const sponsorInstagramInput = document.getElementById('sponsorInstagram');
    const sponsorLinkedinInput = document.getElementById('sponsorLinkedin');
    const sponsorTiktokInput = document.getElementById('sponsorTiktok');
    const sponsorYoutubeInput = document.getElementById('sponsorYoutube');
    const sponsorOtherInput = document.getElementById('sponsorOther');
    const sponsorSubmitBtn = document.getElementById('sponsorSubmitBtn');
    const sponsorCancelBtn = document.getElementById('sponsorCancelBtn');
    const sponsorListContainer = document.getElementById('manage-sponsors-list');

    // --- Helper: Reset Form to "Create" mode ---
    function resetSponsorForm() {
      sponsorForm.reset();
      sponsorEditId.value = '';
      sponsorOldLogoPath.value = '';
      sponsorFormTitle.textContent = 'Add New Sponsor';
      sponsorSubmitBtn.textContent = 'Save Sponsor';
      sponsorCancelBtn.style.display = 'none';
      sponsorUploadProgress.textContent = '';
    }

    // --- Helper: Populate Form for "Edit" mode ---
    async function populateFormForEdit(docId) {
      try {
        const docRef = doc(db, "sponsors", docId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const sponsor = docSnap.data();
          sponsorFormTitle.textContent = `Editing: ${sponsor.name}`;
          sponsorEditId.value = docId;
          sponsorOldLogoPath.value = sponsor.storagePath || '';
          sponsorNameInput.value = sponsor.name;
          sponsorWebsiteInput.value = sponsor.website;
          sponsorFacebookInput.value = sponsor.facebook;
          sponsorInstagramInput.value = sponsor.instagram;
          sponsorLinkedinInput.value = sponsor.linkedin;
          sponsorTiktokInput.value = sponsor.tiktok;
          sponsorYoutubeInput.value = sponsor.youtube;
          sponsorOtherInput.value = sponsor.other;

          sponsorSubmitBtn.textContent = 'Update Sponsor';
          sponsorCancelBtn.style.display = 'inline-block';
          window.scrollTo(0, sponsorForm.offsetTop);
        }
      } catch (error) {
        console.error("Error fetching sponsor for edit:", error);
      }
    }

    // --- 1. Form Submit Logic (Create or Update) ---
    sponsorForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      sponsorSubmitBtn.disabled = true;

      // --- ADD THIS NEW VALIDATION BLOCK ---
    const fieldsToValidate = [
        { el: sponsorWebsiteInput, name: "Website URL" },
        { el: sponsorFacebookInput, name: "Facebook URL" },
        { el: sponsorInstagramInput, name: "Instagram URL" },
        { el: sponsorLinkedinInput, name: "LinkedIn URL" },
        { el: sponsorTiktokInput, name: "TikTok URL" },
        { el: sponsorYoutubeInput, name: "YouTube URL" },
        { el: sponsorOtherInput, name: "Other URL" }
    ];

    for (const field of fieldsToValidate) {
        const value = field.el.value.trim();
        
        // Only validate if the field is not empty
        if (value && !value.startsWith('http://') && !value.startsWith('https://')) {
            alert(`Error: The ${field.name} must start with "http://" or "https://".`);
            sponsorSubmitBtn.disabled = false; // Re-enable the button
            return; // Stop the form submission
        }
    }
    // --- END OF NEW VALIDATION BLOCK ---

      const file = sponsorLogoInput.files[0];
      const editingId = sponsorEditId.value;

      let logoUrl = null;
      let storagePath = null;

      try {
        // --- Step 1: Handle File Upload (if one exists) ---
        if (file) {
          storagePath = `sponsor-logos/${Date.now()}_${file.name}`;
          const storageRef = ref(storage, storagePath);
          const uploadTask = uploadBytesResumable(storageRef, file);

          // Wait for upload to complete
          await new Promise((resolve, reject) => {
            uploadTask.on('state_changed',
              (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                sponsorUploadProgress.textContent = `Upload is ${progress.toFixed(2)}% done`;
              },
              (error) => {
                reject(error);
              },
              async () => {
                logoUrl = await getDownloadURL(uploadTask.snapshot.ref);
                sponsorUploadProgress.textContent = 'Upload complete!';
                resolve();
              }
            );
          });

        }

        // --- Step 2: Prepare Data for Firestore ---
        const sponsorData = {
          name: sponsorNameInput.value,
          website: sponsorWebsiteInput.value,
          facebook: sponsorFacebookInput.value,
          instagram: sponsorInstagramInput.value,
          linkedin: sponsorLinkedinInput.value,
          tiktok: sponsorTiktokInput.value,
          youtube: sponsorYoutubeInput.value,
          other: sponsorOtherInput.value,
        };

        // --- Step 3: Call Callable Function (Create or Update) ---
        if (editingId) {
          // --- UPDATE ---
          sponsorData.docId = editingId;
          // Only add logo fields if a new one was uploaded
          if (logoUrl) {
            sponsorData.logoUrl = logoUrl;
            sponsorData.storagePath = storagePath;
          }
          await updateSponsor(sponsorData);
          alert('Sponsor updated!');
        } else {
          // --- CREATE ---
          if (logoUrl) {
            sponsorData.logoUrl = logoUrl;
            sponsorData.storagePath = storagePath;
          }
          await createSponsor(sponsorData);
          alert('Sponsor created!');
        }

        resetSponsorForm();

      } catch (error) {
        console.error("Sponsor form error:", error);
        alert(`Error: ${error.message}`);
      } finally {
        sponsorSubmitBtn.disabled = false;
      }
    });

    // --- 2. Cancel Edit Button ---
    sponsorCancelBtn.addEventListener('click', resetSponsorForm);

    // --- 3. Display, Delete, and Edit (Event Delegation) ---
    sponsorListContainer.addEventListener('click', async (e) => {
      const target = e.target.closest('button');
      if (!target) return;

      const docId = target.dataset.id;

      // --- Handle Delete ---
      if (target.classList.contains('delete-sponsor-btn')) {
        const storagePath = target.dataset.path;
        if (confirm('Are you sure you want to delete this sponsor?')) {
          try {
            await deleteSponsor({ docId, storagePath: storagePath || null });
            alert('Sponsor deleted.');
          } catch (error) {
            console.error("Delete error:", error);
            alert(`Error: ${error.message}`);
          }
        }
      }

      // --- Handle Edit ---
      if (target.classList.contains('edit-sponsor-btn')) {
        populateFormForEdit(docId);
      }
    });

    // --- 4. Real-time Listener to Render Sponsor List ---
    const q = query(collection(db, "sponsors"), orderBy("order", "asc"));
    onSnapshot(q, (snapshot) => {
      sponsorListContainer.innerHTML = ''; // Clear current list
      snapshot.forEach(docSnap => {
        const sponsor = docSnap.data();
        const sponsorId = docSnap.id;

        const card = document.createElement('div');
        card.className = 'w3-col l3 m6 w3-margin-bottom';
        card.setAttribute('data-id', sponsorId); // For SortableJS

        card.innerHTML = `
            <div class="w3-card">
                <img src="${sponsor.logoUrl}" alt="${sponsor.name}" class="sponsorLogo">
                <div class="w3-container w3-center">
                    <p><b>${sponsor.name}</b></p>
                    <button class="w3-button w3-blue w3-small w3-margin-bottom edit-sponsor-btn" data-id="${sponsorId}">Edit</button>
                    <button class="w3-button w3-red w3-small w3-margin-bottom delete-sponsor-btn" data-id="${sponsorId}" data-path="${sponsor.storagePath || ''}">Delete</button>
                </div>
            </div>
        `;
        sponsorListContainer.appendChild(card);
      });
    });

    // --- 5. Reorder Logic with SortableJS ---
    new Sortable(sponsorListContainer, {
      animation: 150,
      ghostClass: 'w3-opacity',
      onEnd: async (evt) => {
        const items = Array.from(sponsorListContainer.children);
        const orderedIds = items.map(item => item.getAttribute('data-id'));

        try {
          await reorderSponsors({ orderedIds });
          console.log('Sponsor order updated!');
        } catch (error) {
          console.error('Failed to update sponsor order:', error);
        }
      }
    });
  }

  // --- Auth & UI flow ---
  async function handleSignIn(user, handles) {
    handles.loginSection.classList.add("hidden");
    handles.loginLoader.classList.remove("hidden");

    const token = await user.getIdTokenResult();
    const gateFn = httpsCallable(functions, "lilBlessingAccess");
    const { openGateFlag, openGateCode, gateKeeper, returnedKeys } =
      (await gateFn({ currentUrl: location.href, userClaimInfo: token.claims })).data;

    if (openGateFlag !== openGateCode || openGateFlag === gateKeeper) {
      await signOut(auth);
      return handleSignOut(handles);
    }

    window.goodKeys = new Map(Object.entries(returnedKeys));
    handles.logoutButton.addEventListener("click", () => signOut(auth));

    handles.loginLoader.classList.add("hidden");
    handles.page.classList.remove("hidden");

    initTabs();
    renderHomePanel();
    renderStudioPanel();
    renderPricesPanel();
    renderSneakPeek();
    renderGalleryPanel();
    renderFAQPanel();
    renderGenderDeterminationPanel();
    renderSponsorsPanel();
    // …render other panels
    function listenForImages() {
      onSnapshot(doc(db, "imageMappings", "publicImages"), snap => {
        const images = snap.data()?.images || {};
        Object.entries(images).forEach(([key, url]) => {
          const img = document.getElementById(key);
          if (img) img.src = url;
        });
      });
    }

    function listenForStudioCarousel() {
      const carousel = document.getElementById("studioCarousel");
      if (!carousel) {
        console.warn("⚠️ #studioCarousel not found in DOM");
        return;
      }

      onSnapshot(doc(db, "imageMappings", "studioImages"), snap => {
        if (!snap.exists()) {
          console.warn("⚠️ studioImages doc does not exist yet");
          return;
        }
        const items = snap.data()?.imagesArray || [];
        carousel.innerHTML = items.map(item => `
          <div class="studio-thumb">
            <img src="${item.url}">
            <button 
              data-path="${item.path}" 
              class="w3-button w3-small w3-red">
              ✕
            </button>
          </div>
        `).join("");

        // wire delete
        carousel.querySelectorAll("[data-path]").forEach(btn => {
          btn.addEventListener("click", () => {
            const path = btn.dataset.path;
            runWithModal(() => {
              const fn = httpsCallable(functions, window.goodKeys.get("runFunction5"));
              return fn({ page: "studio", path });
            }, {
              loadingMsg: "Deleting photo…",
              loadingTitle: "Deleting",
              loadingColor: "red",
              successMsg: "Photo removed",
              successTitle: "Done",
              successColor: "green"
            });
          });
        });
      });
    }

    // --- Get references to your new Callable Functions ---
    const addPriceBullet = httpsCallable(functions, window.goodKeys.get("runFunction16"));
    const deletePriceBullet = httpsCallable(functions, window.goodKeys.get("runFunction17"));
    const reorderPriceBullets = httpsCallable(functions, window.goodKeys.get("runFunction18"));

    function listenForBullets() {
      // 1) Listen to the bullets doc
      const bulletsRef = doc(db, "textMappings", "priceBullets");

      onSnapshot(bulletsRef, snap => {
        const data = snap.data() || {};

        // for each section key (e.g. priceSlot1…)
        Object.entries(data).forEach(([sectionId, bullets]) => {
          const ul = document.getElementById(`bullets-${sectionId}`);
          if (!ul) return;

          // Check if data is in the old string format and warn user
          if (bullets.length > 0 && typeof bullets[0] === 'string') {
            ul.innerHTML = `<li class="w3-text-red"><b>Error:</b> Data is in old format. Please run the migration script in your console.</li>`;
            return;
          }

          // --- RENDER LIST ITEMS (from new object structure) ---
          ul.innerHTML = bullets.map(bullet => `
        <li class="w3-bar" data-id="${bullet.id}">
          <span class="w3-bar-item">${bullet.text}</span>
          <button 
            data-bullet-remove-id="${bullet.id}"
            data-bullet-section="${sectionId}"
            class="w3-bar-item w3-button w3-small w3-red w3-right">
            ×
          </button>
        </li>
      `).join("");

          // --- WIRE UP REMOVES (now calls backend function) ---
          ul.querySelectorAll("[data-bullet-remove-id]").forEach(btn => {
            btn.addEventListener("click", async () => {
              const sec = btn.dataset.bulletSection;
              const id = btn.dataset.bulletRemoveId;

              if (confirm('Delete this bullet?')) {
                try {
                  btn.disabled = true;
                  await deletePriceBullet({ sectionId: sec, bulletId: id });
                  // UI will update automatically from onSnapshot
                } catch (error) {
                  alert(`Error: ${error.message}`);
                  btn.disabled = false;
                }
              }
            });
          });

          // --- INITIALIZE SORTABLEJS for drag-and-drop ---
          new Sortable(ul, {
            animation: 150,
            ghostClass: 'w3-opacity',
            onEnd: async (evt) => {
              const items = Array.from(ul.children);
              const orderedIds = items.map(item => item.dataset.id);

              try {
                // Call the backend function to save the new order
                await reorderPriceBullets({ sectionId: sectionId, orderedIds: orderedIds });
              } catch (error) {
                console.error('Failed to reorder bullets:', error);
                alert(`Error: ${error.message}`);
              }
            }
          });
        });
      });

      // 2) Wire up add-buttons (now calls backend function)
      document.querySelectorAll("[data-bullet-add]").forEach(btn => {
        btn.addEventListener("click", async () => {
          const sec = btn.dataset.bulletAdd;
          const input = document.getElementById(`bulletInput-${sec}`);
          const txt = input.value.trim();

          if (!txt) return alert("Type a bullet first!");

          try {
            btn.disabled = true;
            input.disabled = true;
            await addPriceBullet({ sectionId: sec, text: txt });
            input.value = ""; // Clear input on success
          } catch (error) {
            alert(`Error: ${error.message}`);
          } finally {
            btn.disabled = false;
            input.disabled = false;
          }
        });
      });
    }

    listenForImages();
    listenForStudioCarousel();
    listenForBullets();
  }

  function handleSignOut(handles) {
    handles.page.classList.add("hidden");
    handles.loginSection.classList.remove("hidden");
  }

  // --- DOM Ready & Auth Watcher ---
  const handles = cacheHandles();

  document.addEventListener("DOMContentLoaded", () => {
    document
      .getElementById("messageModalClose");
    const closeBtn = document.getElementById("messageModalClose");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        document.getElementById("messageModal").classList.add("hidden");
      });
    } else {
      console.warn("⚠️ messageModalClose button not found in DOM");
    }
    // sidebar toggles
    handles.openSidebarBtn.addEventListener("click", () => {
      handles.sidebar.classList.remove("hidden");
      handles.overlay.classList.remove("hidden");
    });
    handles.overlay.addEventListener("click", () => {
      handles.sidebar.classList.add("hidden");
      handles.overlay.classList.add("hidden");
    });

    // sign-in
    handles.gmailButton.addEventListener("click", () => {
      signInWithPopup(auth, new GoogleAuthProvider()).catch(console.error);
    });

    // redirect result
    getRedirectResult(auth).then(res => {
      if (res?.user) handleSignIn(res.user, handles);
    }).catch(console.error);

    // auth state
    onAuthStateChanged(auth, user => {
      if (user) handleSignIn(user, handles);
      else handleSignOut(handles);
    });

  });

}